import { createApi } from "@reduxjs/toolkit/query/react";
import { getBaseQuery } from "../baseQuery";

export interface Dashboard {
  id: string;
  recipeData: {
    title: string;
  };
}

export const dashboardService = createApi({
  reducerPath: "dashboardService",
  baseQuery: getBaseQuery("zeus"),
  endpoints: (builder) => ({
    getDashboard: builder.query<Dashboard, string>({
      query: (dashboardId) => `/api/dashboards/${dashboardId}`,
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardService;
